import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const serviceKeys = [
    'footer.service1', 'footer.service2', 'footer.service3', 'footer.service4', 'footer.service5',
  ];

  return (
    <footer className="bg-[#1e3a4a] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://static.readdy.ai/image/d423d7259cd6886cdb573e095a6b9999/a48c44a5812fde7aa1b743301ff8f67a.png"
                alt="Rise Phoenix Logo"
                className="h-10 w-auto object-contain brightness-200"
              />
              <span className="text-white font-bold text-xl tracking-wide" style={{ fontFamily: "'Playfair Display', serif" }}>
                Rise Phoenix
              </span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-sm mb-7">{t('footer.desc')}</p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-wechat-line', label: 'WeChat' },
                { icon: 'ri-weibo-line', label: 'Weibo' },
                { icon: 'ri-linkedin-box-line', label: 'LinkedIn' },
                { icon: 'ri-github-line', label: 'GitHub' },
              ].map((social) => (
                <a key={social.label} href="#" aria-label={social.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-amber-400 hover:border-amber-400 transition-colors duration-200 cursor-pointer">
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-5">
              <a href="#services" onClick={(e) => { e.preventDefault(); handleNav('#services'); }}>{t('footer.services')}</a>
            </h4>
            <ul className="space-y-3">
              {serviceKeys.map((key) => (
                <li key={key}>
                  <a href="#services" onClick={(e) => { e.preventDefault(); handleNav('#services'); }}
                    className="text-white/55 text-sm hover:text-amber-400 transition-colors duration-200 cursor-pointer">
                    {t(key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-5">{t('footer.contact')}</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-whatsapp-line text-amber-400 text-sm mt-0.5 shrink-0"></i>
                <a
                  href="https://wa.me/6596628319"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/55 text-sm hover:text-amber-400 transition-colors duration-200 cursor-pointer"
                >
                  {t('contact.whatsapp')}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-amber-400 text-sm mt-0.5 shrink-0"></i>
                <a
                  href="mailto:cs@risephoenixtech.com"
                  className="text-white/55 text-sm hover:text-amber-400 transition-colors duration-200 cursor-pointer"
                >
                  {t('contact.email')}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-amber-400 text-sm mt-0.5 shrink-0"></i>
                <span className="text-white/55 text-sm leading-relaxed whitespace-pre-line">{t('footer.address')}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">{t('footer.copyright')}</p>
          <div className="flex items-center gap-6">
            {(['footer.privacy', 'footer.terms', 'footer.sitemap'] as const).map((key) => (
              <a key={key} href="#" rel="nofollow"
                className="text-white/40 text-xs hover:text-amber-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                {t(key)}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
